'use client'

import { RcSuspense } from '@/components/atoms/RcSuspense'
import { useChat } from '@/components/providers/site/ChatProvider'
import { useSocialUserContext } from '@/entity/chat/useSocialUserContext'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { ChatRoom } from './ChatRoom'
import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { RootRoute } from '@/core/route-keys'
import { useNavigation } from '@/core/hooks/useNavigation'

export const ChatDocked = () => {
  const { alerts: notifications } = useSocialUserContext()
  const { handleCloseChat, handleActivate, activeChats } = useChat()
  const { navTo } = useNavigation()

  return (
    <>
      <Box
        sx={theme => ({
          zIndex: theme.zIndex.modal,
          position: 'fixed',
          bottom: 0,
          right: 5
        })}
      >
        <Stack direction='row' spacing={2} alignItems='flex-end'>
          {activeChats?.map(activeChat => {
            const hasUnread = !!notifications?.[activeChat.id]
            return (
              <RcSuspense key={activeChat.id} skipError height={60}>
                <Paper
                  elevation={0}
                  sx={theme => ({
                    zIndex: theme.zIndex.snackbar,
                    height: activeChat.focused ? 'min(80vh,500px)' : 43,
                    width: activeChat.focused ? 390 : 200,
                    border: `1px solid ${theme.palette.divider}`,
                    borderBottom: 0,
                    overflow: 'hidden',
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    borderColor:
                      hasUnread && !activeChat.focused
                        ? theme.palette.warning.main
                        : theme.palette.divider,
                    transition: 'height .25s ease-in, width .25s ease-in'
                  })}
                >
                  <ChatRoom
                    chatId={activeChat.id}
                    onNavigate={() => handleActivate(activeChat.id)}
                    onLeave={() => handleCloseChat(activeChat.id)}
                    onToggle={() => handleActivate(activeChat.id)}
                    autoFocusInput
                    focused={activeChat.focused}
                    action={
                      <>
                        {activeChat.focused ? (
                          <RcIconButton
                            icon={['fal', 'expand']}
                            onClick={e => {
                              e.stopPropagation()
                              navTo({
                                root: RootRoute.Chat,
                                rootId: activeChat.id
                              })
                            }}
                            size={'small'}
                          />
                        ) : null}
                        <RcIconButton
                          icon={['fal', 'times']}
                          onClick={e => {
                            e.stopPropagation()
                            handleCloseChat(activeChat.id)
                          }}
                          size={'small'}
                        />
                      </>
                    }
                  />
                </Paper>
              </RcSuspense>
            )
          })}
        </Stack>
      </Box>
    </>
  )
}
